<script setup lang="ts">
import { TooltipRoot as RadixTooltipRoot, type TooltipRootEmits, type TooltipRootProps, useForwardPropsEmits } from 'radix-vue'

const props = defineProps<TooltipRootProps>()
const emits = defineEmits<TooltipRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <RadixTooltipRoot v-bind="forwarded">
    <slot />
  </RadixTooltipRoot>
</template>
